<template>
  <div>
    <h2>Frequently Asked Questions</h2>
    <ul>
      <li v-for="f in faqs" :key="f.id" class="tw-mb-4">
        <div clasS="tw-text-primary tw-font-bold">
          {{ f.question }}
        </div>
        <div>
          {{ f.answer }}
        </div>
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import apiCall from "@/func/net/apiCall";
import { defineComponent } from "vue";

interface FaqItem {
  id: number;
  question: string;
  answer: string;
  sort: number;
}

export default defineComponent({
  components: {},
  data() {
    return {
      faqs: [] as FaqItem[],
    };
  },
  mounted() {
    this.loadFaqs();
  },
  methods: {
    async loadFaqs() {
      const resData = await apiCall("faq");
      if (resData.success) {
        this.faqs = resData.data.items;
      }
    },
  },
});
</script>
